import Storage from 'disco-storage'

import {
  APP_URL_REDIRECT,
  BUSINESS_SETTINGS_UPDATE_SUCCESS,
  USER_AUTOLOGIN_SUCCESS,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_SETTINGS_UPDATE_SUCCESS,
} from '@disco/constants/ActionTypes'
import i18next from '@disco/i18n/i18next'

import type { Middleware } from 'types/redux'

const languageChange: Middleware =
  () =>
  (next: (...args: Array<any>) => any) =>
  (action: Record<string, any>) => {
    const result = next(action)

    if (
      [
        USER_AUTOLOGIN_SUCCESS,
        USER_LOGIN_SUCCESS,
        USER_SETTINGS_UPDATE_SUCCESS,
        BUSINESS_SETTINGS_UPDATE_SUCCESS,
      ].includes(action.type) &&
      action?.result &&
      (Object.hasOwn(action.result, 'language') ||
        (action.result?.business &&
          Object.hasOwn(action.result.business, 'language')))
    ) {
      // Priority is user language, then business language
      const language =
        action.result?.language || action.result.business?.language || undefined
      Storage.set('i18nextLng', language, { bareString: true })
      i18next.changeLanguage()
    }

    if (action.type === USER_LOGOUT) {
      Storage.set('i18nextLng', null)
      i18next.changeLanguage()
    }

    // Need to detect language again after URL redirect as it may
    // now include a language query parameter
    if (action.type === APP_URL_REDIRECT) {
      i18next.changeLanguage()
    }

    return result
  }

export default languageChange
